(function () {
    'use strict';
    var m = angular.module('common');
    m.factory('singleRowConverter', ["$q", "errorStatusHolder", "parseMIMEByRFC2047", function ($q, errorStatusHolder, parseMIMEByRFC2047) {
        return function (input, args) {
            var deferred = $q.defer();
            if (!input.data.rows.length) {
                if (args.allowEmpty) {
                    deferred.resolve($.extend({}, input, { data: {} }));
                } else {
                    errorStatusHolder.errorStatus(404);
                    deferred.reject({ status: 404 });
                }
            } else {
                _(input.data.rows).each(function (row) {
                    _(row).each(function (column, key) {
                        if (_(column).isString) {
                            row[key] = parseMIMEByRFC2047.decode(column);
                        }
                    });
                });
                var result = _(input.data.rows).first();
                deferred.resolve($.extend({}, input, { data: result }));
            }
            return deferred.promise;
        };
    }]);
}());